<template>
    <div class="px-4">
        <div class="row">
            <div class="col-sm-5">
                <Textarea
                        :disabled=true
                        :inputKey="'label'"
                        :name="titles.Functionaly"
                        :validate="$v.packCountryDomainFunctionality.functionality.label"
                />
            </div>
            <div :class="col">
                <Textarea :name="titles.Details"
                          :inputKey="'details'"
                          :disabled=true
                          :validate="$v.packCountryDomainFunctionality.functionality.details">
                </Textarea>

            </div>
            <div class="col-sm-2" v-if="packCountryDomainFunctionality.functionality.hasValue===true">
                <Input :inputKey="'value'"
                       :name="titles.Value"
                       :validate="$v.packCountryDomainFunctionality.value"
                       @method="getValue"
                />
            </div>
            <div class="col-sm-1 for-delete-functionality">
                <a @click="editFunctionality(item.idPack)" type="button" v-if="selectedFunctionality">
                    <i class="fas fa-check font-20 text-success"></i>
                </a>
                <a @click="deleteFunctionality(item.idPack,item.idFunctionality,item.idPackCountryDomain)"
                   type="button">
                    <i class="fas fa-times font-20 text-danger"></i>
                </a>
            </div>
        </div>
        <div class="displayed col-sm-6">
            <CheckBox
                    :inputKey="'isDisplayed'" :name="titles.displayed"
                    :validate="item.isDisplayed"
                    @method="getValue"/>
        </div>
    </div>
</template>

<script>
    import {titles} from '../../../utils/general/titles';
    import {icons} from '../../../utils/general/icons';
    import Input from '../../common/Input';
    import Textarea from '../../common/Textarea';
    import {required} from 'vuelidate/lib/validators';
    import {packCountryDomainFunctionality} from '../models/packCountryDomainFunctionality';
    import CheckBox from '../../common/CheckBox';

    export default {
        name: 'ExistLineFunctionality',
        components: {
            Input,
            Textarea,
            CheckBox
        },
        props: {
            item: Object
        },
        data() {
            return {
                titles,
                icons,
                packCountryDomainFunctionality: packCountryDomainFunctionality(),
                col: 'col-sm-5',
                colAction: 'col-sm-2',
                selectedFunctionality: false
            };
        },
        created() {
            this.getDisabledFunctionality();
        },
        methods: {
            getDisabledFunctionality() {
                this.packCountryDomainFunctionality.value = this.item.value;
                this.packCountryDomainFunctionality.functionality = this.item;
                this.packCountryDomainFunctionality.functionality.hasValue === false ||
                this.packCountryDomainFunctionality.functionality.hasValue === undefined ?
                    this.col = 'col-sm-6' : this.col = 'col-sm-4';
            },
            getValue(inputKey, val) {
                this.$v.packCountryDomainFunctionality[inputKey].$touch();
                this.packCountryDomainFunctionality[inputKey] = val;
                this.selectedFunctionality = true;
            },
            deleteFunctionality(id, idFunctionality, idPackCOuntryDomain) {
                this.$emit('deleteFunctionality', id, idFunctionality, idPackCOuntryDomain);
            },
            editFunctionality(id) {
                this.selectedFunctionality = false;
                this.$emit('editFunctionality', id, this.packCountryDomainFunctionality.value, this.packCountryDomainFunctionality.isDisplayed);
            }
        },
        validations: {
            packCountryDomainFunctionality: {
                functionality: {
                    id: {required},
                    label: {
                        required
                    },
                    details: {
                        required
                    }
                },
                value: {required},
                isDisplayed: {}
            }
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/base.css';
    .md-textarea {
        overflow: hidden!important;
    }

    .displayed{
      padding-top: 2%;
    }
</style>
